/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useCallback } from "react";
import { useTranslation } from "../lib/react-query/useTranslation";
import { translateString } from "../utils/helpers/translation";

export const useTranslate = () => {
  const pageLang = document.documentElement.lang;
  const { data: translations } = useTranslation(pageLang, { enabled: false });

  const _t = useCallback(
    (str, data = {}) => translateString(str, translations, data),
    [translations]
  );

  return { _t, translations };
};
